export default __webpack_public_path__ + "navigation-examples-custom-banner-v1-1200-0303b4835530b29080ecd4ad89b82d06.webp";